import { buildInstallationPatchFromResolved } from "../mappers/buildInstallationPatchFromResolved";
import { buildRemovalPatchFromResolved } from "../mappers/buildRemovalPatchFromResolved";
import type { ResolvedInstallationOrder } from "../types/installation";
import type { ResolvedRemovalOrder } from "../types/removal";

export async function patchInstallationOrderTaxComplete(
  token: string,
  installationId: string,
  resolved: ResolvedInstallationOrder,
  args: {
    version?: number | string | null;
    installationCost: number;
    existingLineItems: unknown[];
  }
): Promise<void> {
  const patchBody = buildInstallationPatchFromResolved(resolved, {
    ...args,
    taxStatus: "complete",
  });

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`,
    {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(patchBody),
    }
  );

  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(errorText || `Failed to update installation tax (${response.status})`);
  }
}

export async function patchRemovalOrderTaxComplete(
  token: string,
  removalId: string,
  resolved: ResolvedRemovalOrder,
  args: {
    version?: number | string | null;
    removalCost: number;
    existingFeeRows?: unknown[] | null;
    specialFeeCatalog?: unknown[] | null;
  }
): Promise<void> {
  const patchBody = buildRemovalPatchFromResolved(resolved, {
    ...args,
    taxStatus: "complete",
  });

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/removal_orders/${removalId}`,
    {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(patchBody),
    }
  );

  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(errorText || `Failed to update removal tax (${response.status})`);
  }
}
